/**
 * Download a transcript as UTF-8 text.
 */
export class TranscriptTxtExporter {
  constructor({ documentBuilder } = {}) {
    this._builder = documentBuilder;
  }

  async export(conversation) {
    const text = this._builder.build(conversation);
    const stem = this._builder.safeFileStem(conversation?.id || conversation?.visitorSessionId);
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    try {
      this._click(url, `${stem}.txt`);
    } finally {
      URL.revokeObjectURL(url);
    }
  }

  _click(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}
